import { Pipe, PipeTransform } from '@angular/core';
import { Lookup } from '../../../shared-components/lookup/lookup.model';

@Pipe({
  name: 'frmaSuffix'
})
export class FrmaSuffixPipe implements PipeTransform {

  transform(suffixID: number, suffixes: Lookup[]): string {
    let result = '';
    if (suffixes && suffixID) {
      const suffix = suffixes.find(o => o.Id == suffixID.toString());
      if (suffix) {
        result = suffix.CodeDescription;
      }
    }
    return result;
  }

}
